export default function splitPathByFilters(selectedFacetUrl) {
  let pathArr = [];
  /* istanbul ignore else */
  if (selectedFacetUrl && selectedFacetUrl.length) {
    const noStartingSlash = selectedFacetUrl.startsWith('/') ? selectedFacetUrl.slice(1) : selectedFacetUrl;
    let [categories, values] = noStartingSlash.split('/');
    categories = categories?.toUpperCase();
    values = values?.replaceAll('%252C', '%2C'); // remove extra encoding of ', '
    pathArr = [categories, values];
  }

  return pathArr;
}
